import React, { useEffect } from "react";
import './styles.css'
import { useDispatch, useSelector } from "react-redux";
import { fetchBannerById, reset } from "../../../redux/bannerItemSlice";
import { useLocation, useNavigate } from "react-router-dom";
import BannerForm from "./BannerForm";

const EditBanner = () => {
    const { state } = useLocation()
    const navigate = useNavigate()
    let bannerId
    if (state) {
        bannerId = state.bannerId
    }
    const dispatch = useDispatch()

    const banner = useSelector((state) => state.banner)
    useEffect(() => {
        dispatch(fetchBannerById(bannerId))
        return () => {
            dispatch(reset())
        }
    }, [])

    if (!state && banner.bannerId == '') {
        navigate("/banners")
    }


    if (banner.loading) {
        return "Loading"
    }

    if (banner.error) {
        return "Error"
    }
    return (
        <div>
            <p className="create_banner_header">Edit Banner</p>
            <p className="banner_sub_header">Review Banner Details</p>
            <div className="banner_form ">
                <BannerForm banner={banner} action='Update' />
            </div>
        </div>)
}

export default EditBanner